module.exports = __webpack_public_path__ + "static/media/YS_aplusassured_Desktop_EN.c80ca422.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/YS_aplusassured_Desktop_EN.png
// module id = 382
// module chunks = 0